import { types } from 'mobx-state-tree'

const BankIfscData = types.model('BankIfscData', {
  bankName: types.optional(types.string, ''),
  location: types.optional(types.string, ''),
  ifsc: types.optional(types.string, ''),
  branchName: types.optional(types.string, ''),
  branchId: types.optional(types.string, ''),
})

const IfscData = BankIfscData.create({
  bankName: 'State Bank Of India',
  location: 'New Mumbai - Ranchi',
  ifsc: 'SBI000012',
})

export { BankIfscData, IfscData }
